import { useEffect, useRef } from 'react';

/** Open layers, oldest first; Esc goes to the last one only. */
const stack: { current: () => void }[] = [];

function onKeyDown(e: KeyboardEvent) {
  if (e.key !== 'Escape') return;
  const top = stack[stack.length - 1];
  if (!top) return;
  e.preventDefault();
  top.current();
}

/**
 * Esc closes the topmost open layer only (Credits over Options over a Home sub-view), through one
 * window listener. A layer joins the stack while `enabled`; the newest enabled layer is on top.
 */
export function useEscapeLayer(onEscape: () => void, enabled = true) {
  const handler = useRef(onEscape);
  useEffect(() => {
    handler.current = onEscape;
  });
  useEffect(() => {
    if (!enabled) return;
    const layer = handler;
    stack.push(layer);
    if (stack.length === 1) window.addEventListener('keydown', onKeyDown);
    return () => {
      stack.splice(stack.lastIndexOf(layer), 1);
      if (stack.length === 0) window.removeEventListener('keydown', onKeyDown);
    };
  }, [enabled]);
}
